var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryBox01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 12.3097V7.3335H20.1666V12.3097C20.1666 16.0136 20.1666 17.8655 18.9733 19.0162C17.78 20.1668 15.8595 20.1668 12.0184 20.1668H9.9814C6.14033 20.1668 4.21979 20.1668 3.02652 19.0162C1.83325 17.8655 1.83325 16.0136 1.83325 12.3097Z",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 7.3335L2.71478 5.21811C3.39837 3.57752 3.74016 2.75722 4.43295 2.29536C5.12574 1.8335 6.0144 1.8335 7.79171 1.8335H14.2084C15.9857 1.8335 16.8743 1.8335 17.5671 2.29536C18.2599 2.75722 18.6017 3.57752 19.2853 5.21811L20.1667 7.3335",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 7.3335V1.8335",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 11H12.8332",
    stroke: "#666666",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBox01);
export default __webpack_public_path__ + "static/media/delivery-box-01.5c9950f4171bee82b049812b07830801.svg";
export { ForwardRef as ReactComponent };